import { TestImage } from "@assets/constant/index.constant";
import { Button } from "@components/ui/button";
import { GeneralCard, TableCard } from "@ui/internal/components/card";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { endpoint } from "@services/api.services";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { CategoryData, DurationData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { NavLink, useNavigate, useSearchParams } from "react-router";
import { CategoryColumnList } from "../column/index.column";
import CategoryForm from "../form/category.form";
import { ChevronLeft } from "lucide-react";

const index = () => {
  const pathname = usePathname();
  const [searchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch } = useListData<
    QueryData<CategoryData | DurationData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      section:
        searchParams
          .get("data-category")
          ?.toLocaleLowerCase()
          ?.split("-")[0] === "all"
          ? ""
          : searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
    },
    endpoint: endpoint["forms-category"],
    key: `${pathname}-listing`,
    window: true,
  });

  const groupRefetch = () => {
    refetch();
  };

  const columns = CategoryColumnList();

  return (
    <>
      <TableCard
        bulkActions
        inject_ui_table_actions={
          <>
            {/* <Button
              variant={"defaultoutline"}
              onClick={() => {
                navigate("/forms");
              }}
            >
              <ChevronLeft /> Go Back
            </Button> */}
          </>
        }
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={<CategoryForm />}
        formId={pathname}
        // showOrientation
        orientationPosition={false}
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            content={{
              images: [TestImage, TestImage, TestImage],
              title: "Aayush Maharjan",
              subtitle: "Frontend Developer",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        refetch={groupRefetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        endpoint={endpoint["forms-category"]}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
          section:
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] === "all"
              ? ""
              : searchParams
                  .get("data-category")
                  ?.toLocaleLowerCase()
                  ?.split("-")[0] || "",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
